<template>
  <!-- 스펙234_개선_14: [불러오기 제외할 cafe24 주문] 팝업 -->
  <div class="modal-mask" @click.self="$emit('close')">
    <div class="modal">
      <div class="modal-head">
        <h4>불러오기 제외할 cafe24 주문</h4>
        <div class="head-btns"><span class="spacer"></span><button class="ghost" @click="$emit('close')">닫기</button></div>
      </div>

      <p v-if="msg" class="msg">{{ msg }}</p>

      <div class="table-scroll">
        <table class="grid">
          <thead>
            <tr><th style="width:44px;">체크</th><th>주문번호</th><th style="width:80px;">버튼</th></tr>
          </thead>
          <tbody>
            <tr v-for="r in list" :key="r.id">
              <td class="center"><input type="checkbox" :value="r.id" v-model="checked" /></td>
              <td>{{ r.orderNo }}</td>
              <td class="center"><button class="mini del" @click="removeOne(r.id)">삭제</button></td>
            </tr>
            <tr v-if="list.length===0"><td colspan="3" class="empty">등록된 제외 주문이 없습니다.</td></tr>
          </tbody>
        </table>
      </div>

      <!-- 스펙234_개선_16: 직접 입력 대신 [주문 리스트 검색 팝업]에서 선택한 주문번호를 텍스트로 표시 -->
      <div class="add-row">
        <span class="ono-text">주문번호: {{ newNo }}</span>
        <button class="ghost" @click="searchOpen=true">주문 검색</button>
        <button class="primary" @click="addOne" :disabled="!newNo">추가</button>
        <button class="ghost" @click="removeChecked" :disabled="checked.length===0">선택 삭제</button>
      </div>
    </div>

    <!-- 주문 리스트 검색 팝업 -->
    <OrderListSearchDialog v-if="searchOpen" @apply="onOrderPicked" @close="searchOpen=false" />
  </div>
</template>

<script>
import api from '../api';
import OrderListSearchDialog from './OrderListSearchDialog.vue';

export default {
  name: 'OrderExcludeDialog',
  components: { OrderListSearchDialog },
  data() {
    return { list: [], checked: [], newNo: '', msg: '', searchOpen: false };
  },
  created() { this.reload(); },
  methods: {
    async reload() {
      this.msg = ''; this.checked = [];
      try { const res = await api.orderExcludeList(); this.list = res.data || []; }
      catch (e) { this.msg = e.message; this.list = []; }
    },
    // 주문 리스트 검색 팝업에서 선택한 주문번호를 text 에 set
    onOrderPicked(orderNo) { this.newNo = orderNo; this.searchOpen = false; },
    async addOne() {
      const no = (this.newNo || '').trim();
      if (!no) { this.msg = '주문 검색으로 주문번호를 선택하세요.'; return; }
      // 스펙234_개선_18: 추가는 확인창 없이 바로 실행
      try { await api.orderExcludeAdd(no); this.newNo = ''; this.reload(); }
      catch (e) { this.msg = e.message; }
    },
    async removeOne(id) {
      if (!window.confirm('삭제하시겠습니까?')) return;
      try { await api.orderExcludeDelete([id]); this.reload(); }
      catch (e) { this.msg = e.message; }
    },
    async removeChecked() {
      if (this.checked.length === 0) return;
      if (!window.confirm('선택 항목을 삭제하시겠습니까?')) return;
      try { await api.orderExcludeDelete(this.checked.slice()); this.reload(); }
      catch (e) { this.msg = e.message; }
    }
  }
};
</script>

<style scoped>
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.35); display: flex; align-items: center; justify-content: center; z-index: 60; }
.modal { background: #fff; border-radius: 10px; width: 480px; max-width: 92vw; max-height: 84vh; overflow: auto; padding: 14px 16px; }
.modal-head { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
.modal-head h4 { margin: 0; font-size: 15px; color: #263043; }
.head-btns { display: flex; align-items: center; flex: 1; }
.head-btns .spacer { flex: 1 1 auto; }
.msg { color: #c0392b; font-size: 13px; margin: 4px 0; }
.table-scroll { border: 1px solid #e4e9f2; border-radius: 8px; overflow: auto; max-height: 46vh; }
.grid { width: 100%; border-collapse: collapse; font-size: 13px; }
.grid th, .grid td { border-bottom: 1px solid #e4e9f2; padding: 6px 8px; }
.grid thead th { background: #f2f5fb; color: #33405c; }
.grid td.center { text-align: center; }
.grid .empty { text-align: center; color: #8a95ab; padding: 16px; }
.add-row { display: flex; gap: 8px; margin-top: 10px; align-items: center; }
.add-row .ono-text { flex: 1; height: 32px; line-height: 32px; padding: 0 4px; color: #33405c; font-size: 13px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
button { height: 30px; border-radius: 6px; padding: 0 12px; cursor: pointer; font-size: 13px; border: 1px solid #cfd6e6; background: #fff; color: #33405c; }
button.primary { background: #4d8bff; border-color: #4d8bff; color: #fff; }
button.mini { height: 24px; padding: 0 8px; font-size: 12px; }
button.del { color: #c0392b; border-color: #e6b0aa; }
button:disabled { opacity: .5; cursor: default; }
</style>
